<fs-sidenav-menu-items>
  @if (environment && hasSettingsAccess) {
    <button
      fs-sidenav-menu-item
      [routerLink]="['/organization/',environment.id,'settings']"
      (click)="close()">
      Settings
    </button>
  }
  @if (hasAdminWritePermission) {
    <button fs-sidenav-menu-item (click)="create()">Create new organization</button>
  }
  <button fs-sidenav-menu-item (click)="switchOrganization()">Switch organization</button>
</fs-sidenav-menu-items>
